module.exports = __webpack_public_path__ + "GT.png?55c941d7787a4c82c13872c597ed0db9";